export const VERSION: string = "2.0.1";
